/**
 * Self-contained types mirroring the shape of the GraphQL-generated slot data
 * this library operates on. Kept independent of either app's `gql/graphql`
 * (string-literal union instead of generated enum, `GameFormat` reused from
 * `../event/types`) so this library has no dependency on any GraphQL codegen
 * output and can be shared between `mini/` and `web/`. Real generated data
 * structurally satisfies these types without a cast; forwarding a `status` or
 * `event.gameFormat` field read back out of these types into code still typed
 * with the real generated enum needs a matching widened parameter type (see
 * `../event/README.md`'s "widening" note, which applies the same way here).
 */

import type { GameFormat } from '../event/types'

export type SlotStatus = 'OPEN' | 'BOOKED' | 'LOCKED' | 'RESERVED'
export const SlotStatus = {
  Open: 'OPEN',
  Booked: 'BOOKED',
  Locked: 'LOCKED',
  Reserved: 'RESERVED',
} as const satisfies Record<string, SlotStatus>

export type SlotEventMeta = {
  gameFormat: GameFormat
  minRating?: number
  maxRating?: number
  drawSize?: number
  numSignups: number
  fee: string
}

/** Slot data needed for merging/rendering — satisfies `mergeSlots`' `SlotSpanMeta`. */
export type SlotMeta = {
  price: string
  status: SlotStatus
  startTime: string
  reason?: string
  orderId?: string
  eventId?: string
  event?: SlotEventMeta
}
